import { Card, CardHeader, CardBody, InputGroup } from "reactstrap";

const ReportSelectionCard = ({
  title,
  handleChange,
  filterOptions,
  setFilterOptions,
  additionalFilters = "",
  groupEnabled = false,
  groupButtonTitle,
  buttons,
  customFilter = null,
  disable = { date_from: false, date_to: false },
}) => (
  <div className="col-md-6">
    <Card>
      <CardHeader>
        <h5 className="title">{title}</h5>
      </CardHeader>
      <CardBody>
        <div className="row mb-1">
          {!disable?.date_from && (
            <div className="col-12">
              <InputGroup>
                <div className="input-group-prepend">
                  <span className="input-group-text">Date From</span>
                </div>
                <input
                  type="date"
                  className="form-control text-light"
                  name="date_from"
                  onChange={handleChange}
                  value={filterOptions.date_from}
                />
              </InputGroup>
            </div>
          )}
          {!disable?.date_to && (
            <div className="col-12">
              <InputGroup>
                <div className="input-group-prepend">
                  <span className="input-group-text">Date To</span>
                </div>
                <input
                  type="date"
                  name="date_to"
                  onChange={handleChange}
                  value={filterOptions.date_to}
                  className="form-control text-light"
                />
              </InputGroup>
            </div>
          )}
          <div className="col-12">{additionalFilters}</div>
          {groupEnabled && (
            <div className="col-sm-6 col-md-4 col-12">
              <div className="form-check mt-0 mb-3 ml-2">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    onChange={(e) =>
                      setFilterOptions((prev) => ({
                        ...prev,
                        grouped: e.target.checked,
                      }))
                    }
                  />
                  <span className="form-check-sign"></span>
                  {groupButtonTitle}
                </label>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex">{buttons}</div>
      </CardBody>
    </Card>
  </div>
);

export default ReportSelectionCard;
